"use client";
import { GoogleAnalytics } from "@next/third-parties/google";
import Script from "next/script";
import { useCookiesAccepted } from "@/hooks/useCookiesAccepted";

export function Scripts() {
  const { cookiesAccepted } = useCookiesAccepted();

  return (
    <>
      <Script
        id="app-json"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Greenlare",
            url: "https://greenlare.com",
            logo: "https://greenlare.com/logo.png",
            sameAs: ["https://twitter.com/Greenlare"],
          }),
        }}
      />

      <Script
        src="https://analytics.ahrefs.com/analytics.js"
        data-key="ECSXl4WGqLOuiAVWqEMaHQ"
        async
      />

      {cookiesAccepted && (
        <>
          <Script
            async
            defer
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5182294711559790"
            crossOrigin="anonymous"
            strategy="beforeInteractive"
          />
          <GoogleAnalytics gaId="G-1NJZB2NPSX" />
        </>
      )}
    </>
  );
}
